import { useAccountState } from "@made-people/grease-account";
import { StoryblokComponent } from "@made-people/grease-storyblok";
import { SbBlokData } from "@storyblok/js";
import { useGeneralSettings } from "../../../hooks/use-general-settings";
import { ButtonAsLink } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { Heading } from "@made-people/blueprint-heading";
import { RecentOrders } from "./RecentOrders";
import { useGreeting } from "../../../hooks/use-greeting";

export const MissMaryAccountOverview = () => {
  const generalSettings = useGeneralSettings();
  const overviewContent = generalSettings?.overviewContent;
  const accountState = useAccountState();
  const translate = useTranslate();
  const greeting = useGreeting();

  if (!accountState.customer) return null;

  return (
    <div className="flex flex-col gap-6 pb-10">
      <div className="grid md:grid-cols-5 gap-4">
        <div className="md:col-span-3 bg-mandy-100 rounded-2xl p-6 flex flex-col gap-4">
          <Heading
            heading={greeting}
            headingTag="h2"
            variants={{ headingSize: "sm" }}
            className="text-left"
          />
          <p className="text-body-sm">
            {translate("Account_Overview_Subtitle")}
          </p>
        </div>

        <div className="md:col-span-2 bg-white border border-border-light rounded-2xl p-6 block items-start">
          <RecentOrders />
        </div>
      </div>

      <div className="bg-link-water-900 rounded-2xl py-8 px-6 flex flex-col items-center gap-4 text-white">
        <p className="text-body-md text-center">
          {translate("Account_Support_Heading")}
        </p>
        <ButtonAsLink
          label="Upptäck supportsida"
          link={{
            href: "https://support.missmary.com/hc/sv/requests/new",
          }}
          variants={{ color: "white", width: "auto" }}
        />
      </div>

      {overviewContent?.map((component: SbBlokData) => (
        <StoryblokComponent key={component._uid} blok={component} />
      ))}
    </div>
  );
};
